/**
 * PURPOSE: Subir imágenes administrativas para campos URL de Hayllis.
 * RESPONSIBILITIES: Enviar FormData con alcance y devolver la URL pública generada.
 * COLLABORATORS: ImageUrlUploadField.jsx y backend /hayllis-assets/upload.
 * ROUTE: winscore/src/services/hayllisAssetService.js
 */
import axios from "axios";
import API_BASE_URL from "../config/config.js";

export const uploadHayllisAsset = async ({
  file,
  idevent,
  idsport,
  assetType,
}) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_BASE_URL}/hayllis-assets/upload`,
    formData,
    {
      params: {
        idevent: Number(idevent),
        ...(idsport ? { idsport: Number(idsport) } : {}),
        assetType,
      },
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};
